<template>
  <Teleport to="body">
    <div class="overlay" @click="closeModal"></div>
    <div class="modal-wrapper">
      <div class="modal">
        <button class="btn btn-secondary close" @click="closeModal">
          <i class="bi bi-x-lg"></i>
        </button>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <div class="modal-header text-center text-lg-start">
                <h4>
                  <strong>Dividend Projection Calculator </strong>
                  <i class="bi bi-calculator-fill"></i>
                </h4>
              </div>
            </div>
            <div class="col-12">
              <div class="modal-body text-start">
                <slot />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  methods: {
    closeModal() {
      let body = document.querySelector("body");
      this.$store.dispatch("openCalc", false);
      body.classList.toggle("fixed");
    },
  },
};
</script>

<style scoped>
.modal-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 998;
}

.overlay {
  position: fixed;
  z-index: 800;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.modal {
  background: #333;
  z-index: 999;
  height: 600px;
  border-radius: 8px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.26);
  display: block;
  position: inherit;
  top: 10%;
  right: auto;
  left: auto;
  bottom: auto;
}

.light .modal {
  background: #ccc;
}

.modal h4,
.modal h5 {
  color: #ccc;
}

.light .modal h4,
.light .modal h5 {
  color: #333;
}

.modal .modal-header {
  border-bottom: 1px solid #ccc;
}

.light .modal .modal-header.text-center {
  border-bottom: 1px solid #333;
}

.close {
  z-index: 100001;
  position: absolute;
  height: 30px;
  width: 30px;
  top: 10px;
  right: 10px;
  border-radius: 50%;
  background: #fff;
  padding: 0;
  transition: all 0.3s ease-in-out;
}

.close:active,
.close:active i.bi::before {
  transform: rotateZ(720deg) scale(0.8);
}

.modal-body {
  overflow-y: auto;
}

@media (min-width: 1200px) {
  .modal {
    width: 500px;
  }
}

@media (max-width: 1200px) {
  .modal {
    width: 450px;
  }
}

@media (max-width: 768px) {
  .modal {
    width: 400px;
  }
}

@media (max-width: 576px) {
  .modal {
    min-width: 50px;
    width: 350px;
  }
}
</style>
